import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, ArrowUpRight } from "lucide-react";
import { telLink, waLink } from "@/lib/format";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" />
  </svg>
);

export const Footer = ({ settings = {}, vehicles = [] }) => {
  const year = new Date().getFullYear();
  const socials = [
    { href: settings.facebook, icon: Facebook, label: "Facebook" },
    { href: settings.instagram, icon: Instagram, label: "Instagram" },
    { href: settings.tiktok, icon: TikTok, label: "TikTok" },
    { href: settings.youtube, icon: Youtube, label: "YouTube" },
  ].filter((s) => s.href);

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-obsidian">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="pt-16 sm:pt-24">
          <p className="outline-text font-display text-[22vw] font-black leading-[0.8] tracking-[-0.06em] select-none lg:text-[17vw]">JETOUR</p>
        </div>
        <div className="grid gap-12 border-t border-white/10 py-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-display text-2xl font-bold tracking-tight">{settings.dealership_name}</p>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-slate-400">{settings.tagline}. {settings.address}.</p>
            <div className="mt-6 flex flex-col gap-1 font-mono text-sm">
              {settings.phone && <a href={telLink(settings.phone)} className="text-slate-300 hover:text-white" data-testid="footer-phone">{settings.phone}</a>}
              {settings.email && <a href={`mailto:${settings.email}`} className="text-slate-300 hover:text-white" data-testid="footer-email">{settings.email}</a>}
            </div>
            <div className="mt-6 flex gap-3">
              {socials.map(({ href, icon: Icon, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-[border-color,color,transform] duration-300 hover:-translate-y-0.5 hover:border-crimson hover:text-white">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
          <div className="md:col-span-2">
            <p className="eyebrow mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              {[["/models", "Models"], ["/about", "About"], ["/gallery", "Gallery"], ["/test-drive", "Test Drive"], ["/contact", "Contact"]].map(([to, label]) => (
                <li key={to}><Link to={to} className="text-slate-300 transition-colors hover:text-white">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="eyebrow mb-5">Models</p>
            <ul className="space-y-3 text-sm">
              {vehicles.map((v) => (
                <li key={v.slug}><Link to={`/models/${v.slug}`} className="text-slate-300 transition-colors hover:text-white">{v.name.replace("JETOUR ", "")}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Hours</p>
            <div className="space-y-4 text-sm">
              <div><p className="text-slate-500">Showroom</p><p className="text-slate-200">{settings.hours_showroom}</p></div>
              <div><p className="text-slate-500">Workshop</p><p className="text-slate-200">{settings.hours_workshop}</p></div>
            </div>
            {settings.whatsapp && (
              <a href={waLink(settings.whatsapp, "Hello West Canal Motors, I'd like to know more about JETOUR.")} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="mt-6 inline-flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-[0.1em] text-white">
                WhatsApp us <ArrowUpRight className="h-4 w-4 text-crimson" />
              </a>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-3 border-t border-white/10 py-6 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {settings.dealership_name} · Authorized JETOUR 3S Dealer</p>
          <div className="flex items-center gap-6">
            <span>Faisalabad, Pakistan</span>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
